import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoaderService } from './loader.service';
import { ZardLoaderComponent } from '@/shared/zard-ui/components/loader/loader.component';

@Component({
    selector: 'app-global-loader',
    standalone: true,
    imports: [ZardLoaderComponent],
    template: `
    @if (loaderService.isLoading()) {
      <div class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50">
        <z-loader zSize="lg" class="text-white" />
      </div>
    }
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalLoaderComponent {
    protected loaderService = inject(LoaderService);
}
